module.exports = __webpack_public_path__ + "media/icons/theme-switch-icon-default-6779d78f.svg";